import React, { useLayoutEffect } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { usePublicDonate } from '../../contexts/PublicDonateContext';
import DonateCatalogBrowse from '../../components/donate/DonateCatalogBrowse';
import KotilingaSlideshow from '../../components/donate/KotilingaSlideshow';

export default function PublicDonateKotilingaPage() {
  const { addItem, itemCount, donateMode, setGuestMode, cart, removeItem, updateOutOfTownDays } = usePublicDonate();
  const { loading: authLoading, staff } = useAuth();
  const hasPortalSession = !authLoading && !!staff?.portal;

  useLayoutEffect(() => {
    if (authLoading) return;
    if (hasPortalSession) return;
    if (!donateMode) setGuestMode();
  }, [authLoading, hasPortalSession, donateMode, setGuestMode]);

  if (authLoading || (!hasPortalSession && !donateMode)) {
    return (
      <Box sx={{ py: 5, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <DonateCatalogBrowse
      apiPrefix="/public/facets"
      cartPath="/donate/cart"
      addItem={addItem}
      itemCount={itemCount}
      cart={cart}
      removeItem={removeItem}
      updateOutOfTownDays={updateOutOfTownDays}
      topSlot={<KotilingaSlideshow />}
      quickSelectEnvValue={process.env.REACT_APP_KOTILINGA_PRODUCTS}
      searchCategories={process.env.REACT_APP_KOTILINGA_PRODUCT_CATEGORIES || 'kadambavanam'}
      showWelcome={false}
      showUpcomingEvents={false}
      searchTitle="Kotilinga Kshetram - Donations Search"
      searchPlaceholder="Search Kotilinga donations..."
      availableLingasPath="/donate/available-lingas"
    />
  );
}
